import { apiClient } from './client';

export const lessonPlanApi = apiClient.injectEndpoints({
    endpoints: (builder) => ({
        getLessonPlan: builder.query<any, any>({
            query: (bookId) => {
                return {
                    url: `api/books/lessonplan/${bookId}`
                }
            },
            transformResponse: (response: any) => response,
        }),
    }),
});

export const { useGetLessonPlanQuery } = lessonPlanApi;
